module.exports = __webpack_public_path__ + "static/media/clarisses-de-senlis.446de22f.png";